//console.log("custom.js");
function RenderCartSlider() {
  
  console.log("cart_rec_slider");
  if (document.querySelector(".cart_rec_slider")) {
    const pdpUpsellsSwiper = new Swiper(".cart_rec_slider", {
      slidesPerView: 3,
      spaceBetween: 10, // You can adjust this for spacing between slides
      loop: false, // Equivalent to infinite scrolling
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 3,
        },
        610: {
          slidesPerView: 4,
        },
      },
    });
    document.querySelector(".cart_rec_slider").style.opacity = 1;
  }
}

function RenderPreOrder(preOrderElement, preOrderButton) {
  //console.log("RenderPreOrder");
  if (!preOrderElement) return;
  const dataUrl = preOrderElement.getAttribute("data-url");

  if (dataUrl) {
    fetch(dataUrl)
      .then((response) => response.json())
      .then((data) => {
        // Store response in a variable
        let jsonResponsePreOrder = data;

        let PreOrderVariant = jsonResponsePreOrder.variants.find(
          (variant) => variant.title == document.querySelector(".seletect-variant-id").getAttribute("data-title")
        );
        document.querySelector('.custom-pre-order [name="id"]').value = PreOrderVariant.id;

        if (preOrderButton) {
          preOrderButton.addEventListener("click", function () {
            document.querySelector('form.custom-pre-order button[type="submit"]').click();
          });
        }

        // You can use jsonResponse as needed here
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}

function RenderCollectionslider() {
  if (document.querySelector(".collectionSwiper")) {
    //console.log("RenderCollectionslider");
    const varientSlider = new Swiper(".collectionSwiper", {
      slidesPerView: 1,
      speed: 500,
      delay: 100,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

function RederSateches() {
  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document.querySelectorAll(".mobile_quickbuy_trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      this.closest(".product-card").classList.add("quickbuy-active");
    });
  });

  // JavaScript to handle the click event for mobile_quickbuy_trigger
  document.querySelectorAll(".close_button").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      this.closest(".product-card").classList.remove("quickbuy-active");
    });
  });

  // Function to check screen width
  function isScreenAbove700px() {
    return window.innerWidth > 700;
  }

  // Get all product cards
  var productCards = document.querySelectorAll(".product-card");

  // Iterate through each product card
  productCards.forEach(function (card) {
    var figure = card.querySelector(".product-card__figure");
    var swatches = card.querySelector(".swatches_kopstorm");
    if (!figure) return;
    // Function to handle hover in
    function handleHoverIn() {
      if (isScreenAbove700px()) {
        swatches.style.display = "block";
      }
    }

    // Function to handle hover out
    function handleHoverOut() {
      if (isScreenAbove700px()) {
        swatches.style.display = "none";
      }
    }

    // Add event listener for hover in
    figure.addEventListener("mouseover", handleHoverIn);

    // Add event listener for hover out
    figure.addEventListener("mouseout", handleHoverOut);
  });
}

function RenderTagLinks() {
  const facetform = document.querySelectorAll("facets-form form");
  document.querySelectorAll(".collection_product_tags a").forEach((taglink) => {
    taglink.addEventListener("click", (e) => {
      e.preventDefault();
      if (facetform) {
        facetform.forEach((form) => {
          form.setAttribute("action", taglink.getAttribute("href"));
        });
      }
      const checkbox = document.querySelector('[name="filter.v.availability"]');

      if (checkbox) {
        // checkbox.checked = false; // Toggle or set true/false
        checkbox.dispatchEvent(new Event("change", {bubbles: true}));
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  //console.log("DOM fully loaded and parsed");

  RenderCollectionslider();
  RederSateches();
  RenderTagLinks();
  RenderCartSlider();
  setTimeout(function () {
    RederSateches();
  }, 3000);

  document.addEventListener("cart:refresh", (event) => {
    console.log("cart:refresh");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });
  document.addEventListener("cart:change", (event) => {
    console.log("cart:change");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });
  document.addEventListener("cart:prepare-bundled-sections", (event) => {
    console.log("cart:prepare-bundled-sections");
    setTimeout(function () {
      RenderCartSlider();
    }, 200);
  });

  if (document.querySelector(".varient_slider")) {
    const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 6.5, // Default for mobile
      spaceBetween: 3,
      freeMode: true, // Enables free scrolling
      freeModeMomentum: true, // Adds momentum for natural feel
      freeModeMomentumRatio: 1, // Controls momentum strength
      freeModeMomentumVelocityRatio: 0.5, // Controls speed of momentum
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // Tablet and up: maintain your original settings
        768: {
          slidesPerView: 7.5,
          spaceBetween: 5,
          freeMode: false, // Disable free mode on larger screens
        },
        992: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
        1200: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
      },
      // Optional: Disable navigation buttons on mobile if not needed
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            //this.navigation.destroy();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            // this.navigation.destroy();
          } else {
            // this.navigation.init();
          }
        },
      },
    });

    // Get all slides as an array
    const slides = Array.from(varientSlider.slides);

    // Sort slides based on data-index attribute
    slides.sort((a, b) => {
      const indexA = parseInt(a.getAttribute("data-index")) || 6;
      const indexB = parseInt(b.getAttribute("data-index")) || 6;
      return indexA - indexB; // Ascending order (use indexB - indexA for descending)
    });

    // Remove all existing slides
    varientSlider.removeAllSlides();

    // Append sorted slides
    slides.forEach((slide) => varientSlider.appendSlide(slide));

    // Update Swiper to reflect changes
    varientSlider.update();

    document.querySelector(".cust_swatches").removeAttribute("style");
    const activeSlideIndex = Array.from(document.querySelectorAll(".varient_slider .swiper-slide")).findIndex((slide) =>
      slide.classList.contains("activeslide")
    );
    //varientSlider.slideTo(activeSlideIndex);
  }

  let preOrderElement = document.querySelector(".custom-pre-order");

  const addToCartButton = document.querySelector('product-form button[type="submit"]');
  document.addEventListener("variant:change", function (event) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');
    // console.log(event.detail);

    if (document.querySelector(".seletect-variant-id")) {
      document.querySelector(".seletect-variant-id").setAttribute("data-title", event.detail.variant.title);
    }
    RenderPreOrder(preOrderElement, preOrderButton);

  });

  document.addEventListener("facet:update", function (event) {
    //console.log("facet");
    setTimeout(function () {
      RenderTagLinks();
      RenderInfinteProduct();
    }, 1500);
    setTimeout(function () {
      RenderCollectionslider();
      RederSateches();
    }, 3000);
  });

  if (document.querySelector(".pdp-upsells")) {
 

    document.querySelectorAll(".upsell-img-slider").forEach((slider, index) => {
      const nextEl = slider.querySelector(".swiper-button-next");
      const prevEl = slider.querySelector(".swiper-button-prev");

      const options = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        watchOverflow: true,
      };

      if (nextEl && prevEl) {
        options.navigation = {
          nextEl,
          prevEl,
        };
      }

      new Swiper(slider, options);
    });
  }
  //console.log('preOrderElement', preOrderElement);
  if (preOrderElement) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');

    RenderPreOrder(preOrderElement, preOrderButton);
  }
});

// Feature Fact Swiper JS
if (document.querySelector(".feature_fact_slider")) {
  var swiper = new Swiper(".feature_fact_slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
  document.querySelector(".features_fact").removeAttribute("style");
}
if (document.querySelector(".upsell-img-slider")) {
  var swiper = new Swiper(".upsell-img-slider", {
    speed: 300,
    delay: 20,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const showFeatureFacts = document.querySelectorAll(".show_ff_content");

if (showFeatureFacts) {
  showFeatureFacts.forEach((button) => {
    button.addEventListener("click", function () {
      button.parentNode.classList.toggle("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const productSelect = document.querySelectorAll(".product_list_upsell");

  // Function to fetch product variants
  async function fetchProductVariants(productHandle) {
    try {
      // Shopify AJAX API endpoint to fetch product data
      const response = await fetch(`${productHandle}.js`);
      const product = await response.json();
      return product.variants;
    } catch (error) {
      console.error("Error fetching product variants:", error);
      return [];
    }
  }

  // Function to update variant dropdown
  function updateVariantDropdown(variants, variantSelectOption) {
    // Clear existing options
    const variantSelect = variantSelectOption.nextElementSibling;
    //console.log(variantSelect);
    if (!variantSelect) return; // Ensure the select element exists
    variantSelect.innerHTML = "";

    // Populate new options
    variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.disabled = true;
        option.style.textDecoration = "line-through";
        option.textContent += " (sold out)";
      }
      variantSelect.appendChild(option);
    });
  }

  // Event listener for product selection change
  if (productSelect) {
    productSelect.forEach((select) => {
      select.addEventListener("change", async () => {
        const selectedProductHandle = select.value;
        if (selectedProductHandle) {
          const variants = await fetchProductVariants(selectedProductHandle);
          updateVariantDropdown(variants, select);
        }
      });
    });
  }

  document.addEventListener("recommendations:change", function (event) {
    //console.log("recommendations changed");
  });

  const custSwatches = document.querySelector(".cust_swatches");
  const dynamicColor = document.querySelector(".dynamic_color");

  if (custSwatches && dynamicColor) {
    const container = document.querySelector(".varient_info_wrapper"); // the wrapper around all swatches
    const items = Array.from(container.querySelectorAll(".product_swatch_box_container"));

    // sort by data-index (numerically)
    items.sort((a, b) => +a.dataset.index - +b.dataset.index);

    // re-append sorted elements to the DOM
    items.forEach((item) => container.appendChild(item));

    const swatchBoxes = custSwatches.querySelectorAll(".product_swatch_box_container");

    function updateActiveColor() {
      const active = custSwatches.querySelector(".product_swatch_box_container.activeslide");
      if (active) {
        const color = active.getAttribute("data-color");
        dynamicColor.textContent = color;
      }
    }

    // Run once on load
    updateActiveColor();

    swatchBoxes.forEach((box) => {
      box.addEventListener("mouseenter", () => {
        const hoverColor = box.getAttribute("data-color");
        if (hoverColor) {
          dynamicColor.textContent = hoverColor;
        }
      });

      box.addEventListener("mouseleave", () => {
        updateActiveColor();
      });
    });
  }

  if (document.querySelectorAll(".expandable_icon").length > 0) {
    document.querySelectorAll(".expandable_icon").forEach((icon) => {
      icon.addEventListener("click", function (event) {
        event.stopPropagation();

        this.classList.toggle("active");
        this.querySelector(".scale_text_container")?.classList.toggle("show");
      });

      // Simulate initial click
      icon.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      // Simulate click again after 9 seconds
      setTimeout(() => {
        icon.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 6000);
    });
  }
});

function RenderInfinteProduct() {
  const grid = document.querySelector(".product-list");
  const pagination = document.querySelector(".pagination");
  if (!grid || !pagination) return;

  let loading = false;
  let nextPageUrl = pagination.querySelector("a[rel='next']")?.href;

  // Hide normal pagination
  pagination.style.display = "none";

  // Create a small loader
  const loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.innerHTML = "<p>Loading more products...</p>";
  loader.style.textAlign = "center";
  loader.style.padding = "20px 0";
  loader.style.display = "none";
  grid.after(loader);

  const loadMoreProducts = () => {
    if (!nextPageUrl || loading) return;
    loading = true;
    loader.style.display = "block";

    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProducts = doc.querySelector(".product-list");
        const newPagination = doc.querySelector(".pagination");

        if (newProducts) {
          grid.insertAdjacentHTML("beforeend", newProducts.innerHTML);
        }

        nextPageUrl = newPagination?.querySelector("a[rel='next']")?.href || null;
        loading = false;
        loader.style.display = "none";
        RenderCollectionslider();
        RederSateches();
      })
      .catch((err) => {
        console.error("Infinite scroll error:", err);
        loading = false;
        loader.style.display = "none";
      });
  };

  // Load more when user is near bottom (500–800px away)
  window.addEventListener("scroll", () => {
    if (!nextPageUrl || loading) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.body.offsetHeight - 2000; // start loading 800px before bottom

    if (scrollPosition >= threshold) {
      loadMoreProducts();
    }
  });
}
//const EUR_GOAL = 100;                                  // Threshold (EUR)
//const FREE_GIFT_VARIANT_ID = 53886393778499;          // Free gift variant
const EUR_GOAL_SOCKS = 100;                             // First milestone
const FREE_GIFT_VARIANT_ID_SOCKS = 53886393778499;      // Free socks variant

const EUR_GOAL_BAG = 120;                               // Second milestone
const FREE_GIFT_VARIANT_ID_BAG = 53918236442947;        // Free bag variant



const EUR_GOAL_CAP = 150;                               
const FREE_GIFT_VARIANT_ID_CAP = 53960998551875;        // Free Cap

const EUR_GOAL_BEANIE = 180;                               
const FREE_GIFT_VARIANT_ID_BEANIE = 53935632089411;        // Free Cap



//---------------------------------------------
// UTIL: Convert local (minor units) → EUR
//---------------------------------------------
function convertToEUR(amountInMinor) {
  if (Shopify?.currency?.rate) {
    return (Number(amountInMinor) / 100) / Shopify.currency.rate;
  }
  return 0;
}

//---------------------------------------------
// UTIL: Fetch cart once
//---------------------------------------------
async function getCart() {
  const response = await fetch('/cart.js');
  return await response.json();
}

//---------------------------------------------
// UPDATE THE UI (MESSAGE + PROGRESS BAR + DOTS)
//---------------------------------------------
function updateMilestoneUI(spentInEUR) {
  const messageEl = document.getElementById("free-shipping-banner");
  const socksDot = document.querySelector(".Euromilestore_socks");
  const bagDot = document.querySelector(".Euromilestore_bag");
  const giveawayDot = document.querySelector(".Euromilestore_giveaway");
  const Euromilestore_cap_dot = document.querySelector(".Euromilestore_cap");
  const Euromilestore_beanies_dot =  document.querySelector(".Euromilestore_beanies");

  if (!messageEl) return;

  const remainingToSocks = EUR_GOAL_SOCKS - spentInEUR;
  const remainingToBag = EUR_GOAL_BAG - spentInEUR;
  const remainingTocap = EUR_GOAL_CAP - spentInEUR;
  const remainingTobeanie = EUR_GOAL_BEANIE - spentInEUR;


  // Determine what message to show
  if (spentInEUR >= EUR_GOAL_BEANIE) {
    messageEl.innerHTML = ``;
    socksDot?.classList.add("reached");
    bagDot?.classList.add("reached");
    giveawayDot?.classList.add("reached");
    Euromilestore_cap_dot?.classList.add("reached");
    Euromilestore_beanies_dot?.classList.add("reached");
  } else if (spentInEUR >= EUR_GOAL_CAP) {
    console.log(spentInEUR +">="+ EUR_GOAL_CAP);
 // enter Beanie
    const neededLocal = remainingTobeanie * Shopify.currency.rate;
    messageEl.innerHTML = `Spend ${neededLocal.toFixed(2)} ${Shopify.currency.active} more to get a <b>GIFT 4</b>!`;
    socksDot?.classList.add("reached");
    bagDot?.classList.add("reached");
    giveawayDot?.classList.add("reached");
    Euromilestore_cap_dot?.classList.add("reached");
    Euromilestore_beanies_dot?.classList.remove("reached");
  }else if (spentInEUR >= EUR_GOAL_BAG) {
 // enter Cap
    const neededLocal = remainingTocap * Shopify.currency.rate;
    messageEl.innerHTML = `Spend ${neededLocal.toFixed(2)} ${Shopify.currency.active} more to get a <b>GIFT 3</b>!`;
    socksDot?.classList.add("reached");
    bagDot?.classList.add("reached");
    giveawayDot?.classList.add("reached");
    Euromilestore_cap_dot?.classList.remove("reached");
    Euromilestore_beanies_dot?.classList.remove("reached");
  }else if (spentInEUR >= EUR_GOAL_SOCKS) {
    // Get free bag
    const neededLocal = remainingToBag * Shopify.currency.rate;
    messageEl.innerHTML = `Spend ${neededLocal.toFixed(2)} ${Shopify.currency.active} more to get a <b>GIFT 2</b>!`;
    socksDot?.classList.add("reached");
    bagDot?.classList.remove("reached");
    giveawayDot?.classList.remove("reached");
    Euromilestore_cap_dot?.classList.remove("reached");
    Euromilestore_beanies_dot?.classList.remove("reached");
  } else {
    // Get free socks
    const neededLocal = remainingToSocks * Shopify.currency.rate;
    messageEl.innerHTML = `Spend ${neededLocal.toFixed(2)} ${Shopify.currency.active} more to Get <b>GIFT 1</b>`;
    socksDot?.classList.remove("reached");
    bagDot?.classList.remove("reached");
    giveawayDot?.classList.remove("reached");
    Euromilestore_cap_dot?.classList.remove("reached");
    Euromilestore_beanies_dot?.classList.remove("reached");
  }

  // Update progress bar (goes up to 140€ now)
  let reduceprogres = 0;/*
  if(0 < remainingToSocks * Shopify.currency.rate || 0 < remainingToBag * Shopify.currency.rate)
  {
    reduceprogres = 10;
  }*/
  const overallProgress = Math.min((spentInEUR / EUR_GOAL_BEANIE) * 100, 100).toFixed(1)-reduceprogres + "%";
  document.querySelector(".milestone-line-inner")
    ?.style.setProperty("--progress", overallProgress);
}

//---------------------------------------------
// ADD or REMOVE FREE GIFTS (both)
//---------------------------------------------
async function updateGifts(cart, spentInEUR) {
  const hasSocks = cart.items.some(item => item.variant_id == FREE_GIFT_VARIANT_ID_SOCKS);
  const hasBag = cart.items.some(item => item.variant_id == FREE_GIFT_VARIANT_ID_BAG);
  const hasCap = cart.items.some(item => item.variant_id == FREE_GIFT_VARIANT_ID_CAP);
  const hasBeanie = cart.items.some(item => item.variant_id == FREE_GIFT_VARIANT_ID_BEANIE);

  const meetsSocks = spentInEUR >= EUR_GOAL_SOCKS;
  const meetsBag = spentInEUR >= EUR_GOAL_BAG;
  const meetsCap = spentInEUR >= EUR_GOAL_CAP;
  const meetsBeanie = spentInEUR >= EUR_GOAL_BEANIE;
  let changed = false;

  // --- Socks Gift ---
  if (meetsSocks && !hasSocks) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT_VARIANT_ID_SOCKS, quantity: 1 }],
      }),
    });
    changed = true;
  } else if (!meetsSocks && hasSocks) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: { [FREE_GIFT_VARIANT_ID_SOCKS]: 0 },
      }),
    });
    changed = true;
  }

  // --- Bag Gift ---
  if (meetsBag && !hasBag) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT_VARIANT_ID_BAG, quantity: 1 }],
      }),
    });
    changed = true;
  } else if (!meetsBag && hasBag) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: { [FREE_GIFT_VARIANT_ID_BAG]: 0 },
      }),
    });
    changed = true;
  }


  // ---- CAP -------
  if (meetsCap && !hasCap) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT_VARIANT_ID_CAP, quantity: 1 }],
      }),
    });
    changed = true;
  } else if (!meetsCap && hasCap) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: { [FREE_GIFT_VARIANT_ID_CAP]: 0 },
      }),
    });
    changed = true;
  }

  // ---- Beanie -------
  if (meetsBeanie && !hasBeanie) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: FREE_GIFT_VARIANT_ID_BEANIE, quantity: 1 }],
      }),
    });
    changed = true;
  } else if (!meetsBeanie && hasBeanie) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: { [FREE_GIFT_VARIANT_ID_BEANIE]: 0 },
      }),
    });
    changed = true;
  }


  if (changed) {
    document.dispatchEvent(new Event("cart:refresh"));
  }
  return changed;
}

//---------------------------------------------
// MAIN FUNCTION
//---------------------------------------------
async function updateMilestoneMessage() {
  const banner = document.getElementById("free-shipping-banner");
  if (!banner) return;

  const cartTotalMinor = banner.getAttribute("data-total");
  const spentInEUR = convertToEUR(cartTotalMinor);

  // Update UI instantly
  updateMilestoneUI(spentInEUR);

  // Prevent multiple updates
  if (document.body.classList.contains("cartupdating")) return;
  document.body.classList.add("cartupdating");

  try {
    const cart = await getCart();
    const changed = await updateGifts(cart, spentInEUR);

    if (changed) {
      // Re-check after cart updates settle
      setTimeout(() => {
        updateMilestoneMessage();
        RenderCartSlider?.();
      }, 1200);

       // Re-check after cart updates settle
      setTimeout(() => {
        updateMilestoneMessage();
        RenderCartSlider?.();
      }, 3000);

    }
  } finally {
    setTimeout(() => document.body.classList.remove("cartupdating"), 1500);
  }
}

//---------------------------------------------
// EVENT BINDINGS
//---------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
  RenderInfinteProduct?.();
  updateMilestoneMessage();
});

document.addEventListener("cart:change", () => {
  setTimeout(updateMilestoneMessage, 800);
});